<div [class]="computedWrapperClasses">
  <input
    [type]="type"
    [value]="value"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel"
    [ngClass]="computedInputClasses"
    (input)="onInput($event)"
  />

  @if (showClearButton) {
    <button
      type="button"
      [class]="computedClearBtnClasses"
      (click)="onClear()"
      [attr.aria-label]="'Clear ' + (ariaLabel || 'input')"
    >
      ×
    </button>
  }
</div>
